var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrankcall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 107,
    viewBox: "0 0 119 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2105 39.9154C30.8775 32.2992 35.971 25.0444 43.5873 23.7114L66.1707 19.7588C73.7869 18.4258 81.0417 23.5194 82.3747 31.1356L86.3273 53.7191C87.6603 61.3353 82.5667 68.5901 74.9505 69.9231L52.367 73.8756C44.7508 75.2086 37.496 70.1151 36.163 62.4989L32.2105 39.9154Z",
    fill: "url(#paint0_linear_8040_11185)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2105 39.9154C30.8775 32.2992 35.971 25.0444 43.5873 23.7114L66.1707 19.7588C73.7869 18.4258 81.0417 23.5194 82.3747 31.1356L86.3273 53.7191C87.6603 61.3353 82.5667 68.5901 74.9505 69.9231L52.367 73.8756C44.7508 75.2086 37.496 70.1151 36.163 62.4989L32.2105 39.9154Z",
    fill: "url(#paint1_linear_8040_11185)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2396 44.3462C69.1016 49.2714 65.5422 52.4323 61.0494 54.6907C60.8138 54.8069 60.5434 54.8506 60.2838 54.8145C55.2814 54.2282 50.86 52.464 49.998 47.5389L48.7912 40.6437C48.7455 40.3824 48.8218 40.1109 49.0033 39.8887C49.1847 39.6666 49.4566 39.512 49.7589 39.4591C52.0391 39.06 54.6825 37.3791 56.4042 35.5347C56.6145 35.3141 56.9046 35.1624 57.2223 35.1068C57.54 35.0512 57.8644 35.0954 58.1371 35.2314C60.3961 36.3893 63.4401 37.0646 65.7203 36.6655C66.0226 36.6126 66.3308 36.6657 66.5769 36.813C66.8231 36.9603 66.987 37.1898 67.0328 37.451L68.2396 44.3462Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_8040_11185",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1426 25.1374C63.4813 21.3595 66.0079 17.7609 69.7859 17.0996C73.5638 16.4384 77.1625 18.965 77.8237 22.743C78.4849 26.5209 75.9583 30.1196 72.1804 30.7808C68.4024 31.442 64.8038 28.9154 64.1426 25.1374Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.1426 25.1374C63.4813 21.3595 66.0079 17.7609 69.7859 17.0996C73.5638 16.4384 77.1625 18.965 77.8237 22.743C78.4849 26.5209 75.9583 30.1196 72.1804 30.7808C68.4024 31.442 64.8038 28.9154 64.1426 25.1374Z",
    fill: "url(#paint2_linear_8040_11185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1426 25.1374M77.8237 22.743M77.8237 22.743M64.1426 25.1374M69.7859 17.0996M77.8237 22.743M72.1804 30.7808M64.1426 25.1374M72.1804 30.7808L71.8356 28.8107C69.1457 29.2815 66.5834 27.4826 66.1126 24.7926L64.1426 25.1374L62.1725 25.4822C63.0241 30.3482 67.6592 33.6025 72.5252 32.7508L72.1804 30.7808ZM77.8237 22.743L75.8536 23.0878C76.3244 25.7777 74.5255 28.3399 71.8356 28.8107L72.1804 30.7808L72.5252 32.7508C77.3911 31.8992 80.6454 27.2641 79.7937 22.3982L77.8237 22.743ZM69.7859 17.0996L70.1307 19.0697C72.8206 18.5989 75.3828 20.3979 75.8536 23.0878L77.8237 22.743L79.7937 22.3982C78.9421 17.5322 74.3071 14.2779 69.4411 15.1296L69.7859 17.0996ZM69.7859 17.0996L69.4411 15.1296C64.5751 15.9812 61.3209 20.6163 62.1725 25.4822L64.1426 25.1374L66.1126 24.7926C65.6418 22.1027 67.4408 19.5405 70.1307 19.0697L69.7859 17.0996Z",
    fill: "white",
    mask: "url(#path-4-inside-1_8040_11185)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11185",
    x: -2.20312,
    y: -14.6562,
    width: 122.945,
    height: 122.945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11185"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11185",
    x: 17.7969,
    y: 15.3438,
    width: 82.9453,
    height: 82.9453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11185",
    result: "effect2_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11185",
    x: 50.9453,
    y: 13.9062,
    width: 40.0781,
    height: 40.0703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11185",
    result: "effect2_dropShadow_8040_11185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11185",
    x1: 29.7969,
    y1: 26.125,
    x2: 88.7409,
    y2: 67.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB2C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11185",
    x1: 29.7969,
    y1: 26.125,
    x2: 88.7409,
    y2: 67.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB2C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70036"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11185",
    x1: 62.9453,
    y1: 18.2969,
    x2: 79.0209,
    y2: 29.5835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB2C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.7782,
    height: 24,
    fill: "white",
    transform: "translate(43.1953 35.5312) rotate(-9.92739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrankcall);
export default __webpack_public_path__ + "static/media/Prank call.66177757f8a1d117f8818c8366ee9f71.svg";
export { ForwardRef as ReactComponent };